import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { HeaderColumnComponent } from '../header-column.component';

@Component({
  selector: 'app-header-column-energy-score',
  templateUrl: './header-column-energy-score.component.html',
  styleUrls: ['./header-column-energy-score.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnEnergyScoreComponent extends HeaderColumnComponent {}
